module.exports = __webpack_public_path__ + "static/img/logo.a6a97a6c.png";